<template>
  <v-card>
    <v-card-text>
      <div class="font-weight-bold">
        {{ product.name }}
      </div>
      <div class="primary--text headline">
        <template v-if="price.price != price.discount"> ฿{{ price.discount }} </template>
        <template v-else>฿{{ price.price }}</template>
      </div>
      <div v-if="price.price != price.discount" class="strikethrough grey--text mb-2">
        ฿{{ price.price }}
      </div>
      <template v-if="productcategory && productcategory.length > 0">
        <product-option
          v-model="currentOption"
          @changeOption="onChangeOption"
          :stock="productstock"
          :category="productcategory"
        ></product-option>
      </template>
      <template v-else>
        <template v-for="(stype, sindex) in productstock">
          <v-chip
            :key="'stock_' + sindex"
            depressed
            :dark="currentOption && stype[0] == currentOption[0]"
            :color="currentOption && stype[0] == currentOption[0] ? 'primary' : ''"
          >
            <v-avatar v-if="stype[7]">
              <img :src="stype[7]" :alt="stype[1]" />
            </v-avatar>
            {{ stype[1] }}
          </v-chip>
        </template>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import ProductOption from './ProductOption'
export default {
  props: ['value', 'productcategory', 'product', 'productstock'],
  data() {
    return {
      currentOption: this.value
    }
  },
  components: {
    ProductOption
  },
  mounted() {
    this.currentOption = this.productstock[0]
  },
  computed: {
    price() {
      if (this.currentOption) {
        var stock = this.productstock.find((el) => {
          return el[1] == this.currentOption[1]
        })

        if (stock) {
          if (stock[3] == null && stock[4] == null) {
            // console.log('has stock. both empty')
            return {
              price: this.product.price ? parseFloat(this.product.price) : 0,
              discount: this.product.discountprice ? parseFloat(this.product.discountprice) : 0
            }
          } else {
            // console.log('has stock')
            return {
              price: stock[3] == null ? this.product.price : stock[3],
              discount: stock[4] == null ? stock[3] : stock[4]
            }
          }
        }
      }

      return {
        price: this.product.price,
        discount: this.product.discountprice
      }
    }
  },
  methods: {
    onChangeOption(type) {
      var stock = this.productstock.find((el) => {
        // console.log(el[1]);
        return el[1] == type
      })

      if (stock) {
        this.currentOption = stock
      } else {
        this.currentOption = null
      }
    }
  },
  watch: {
    productstock() {
      if (!this.currentOption) {
        this.currentOption = this.productstock[0]
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/PreviewProduct.vue